import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { TranslateService } from '@ngx-translate/core';
import { UserInfo } from 'src/app/models/user-info.model';
import { UsersService } from 'src/app/services/users/users.service';
import { Error } from 'src/app/models/error.model';
import { lastValueFrom } from 'rxjs';
import { GraphService } from 'src/app/services/graph/graph.service';
import { Router } from '@angular/router';
import { entAnimations } from 'src/app/animations';

@Component({
  selector: 'app-user-microsoft-dialog',
  templateUrl: './user-microsoft-form.component.html',
  styleUrl: './user-microsoft-form.component.scss',
  encapsulation: ViewEncapsulation.None,
  animations: entAnimations,
  standalone: false,
})
export class User365FormDialogComponent {
  currentUser: UserInfo = new UserInfo();
  error: Error = { error: { message: '', code: '' } };
  isBusyVerifyAvs = false;
  isInfoIncorrect = false;
  NameNotNumberValidation = '^([^0-9]*)$';
  emailPatternValidator = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  userExist: boolean;
  spinner = {
    color: 'primary',
    mode: 'indeterminate' as ProgressSpinnerMode,
    value: 50,
    diameter: 50,
  };

  getUserForm: FormGroup;

  constructor(
    public matDialogRef: MatDialogRef<User365FormDialogComponent>,
    private _formBuilder: FormBuilder,
    private _userService: UsersService,
    private _translateService: TranslateService,
    private _graphService: GraphService,
    private _router: Router
  ) {
    this.getUserForm = this._formBuilder.group({
      email: [
        '',
        [Validators.required, Validators.pattern(this.emailPatternValidator)],
      ],
    });
  }

  async get365User() {
    this.isBusyVerifyAvs = true;
    this.isInfoIncorrect = false;
    try {
      this.userExist = await lastValueFrom(
        this._graphService.canUserBeAccepted(this.email)
      );
    } catch {
      this.isInfoIncorrect = true;
    } finally {
      this.isBusyVerifyAvs = false;
    }
  }

  async seeUserProfile() {
    await this.get365User();
    if (this.userExist) {
      this._router.navigate(['user365/' + this.email]);
      this.matDialogRef.close();
    } else {
      this.isInfoIncorrect = true;
    }
  }

  get email(): string {
    return this.getUserForm.get('email').value;
  }
}
